import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
import { TrackMouseMove } from "../../TrackMouseMove.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState"]);
const SaturationBox = styled(TrackMouseMove, {
  name: colorPickerName,
  overridesResolver: (_props, styles) => [styles.saturation],
  shouldForwardProp: (prop) => !doNotForward.has(prop),
  slot: "Saturation"
})(({ theme }) => ({
  backgroundImage: "linear-gradient(transparent, black), linear-gradient(to right, white, transparent)",
  borderRadius: theme.spacing(0.5),
  boxShadow: "inset 0 1px 1px 0.5px #0003",
  flexGrow: 1,
  height: "100%",
  position: "relative",
  userSelect: "none"
}));
export {
  SaturationBox
};
//# sourceMappingURL=SaturationBox.js.map
